
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { getRemotedbUrl, i18nIntl, importCSS } from '../../lib/ep.js';
import { size as _size , orderBy as _orderBy } from 'lodash';
import { sweep as const_sweep } from './bootstrap';
import { HashRouter as Router, Route } from 'react-router-dom';
import QRCode from 'qrcode.react';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import DigitImage from '../builder/DigitImage';
import SaveButton from '../builder/SaveButton';
import Spinner from '../builder/Spinner';
import TimeCounterPerform from '../builder/TimeCounterPerform.js';

import SweepSettings from './SweepSettings';
import SweepsLiveProjectionManage from './SweepsLiveProjectionManage';

const ChartRowBar = (props) => {
	const answer_state = (props.state != undefined) ? props.state : false;
	const main_color = (props.main_color != undefined) ? props.main_color : false;

	var bar_styles = { width:props.width + '%' };
	if(main_color) {
		bar_styles.background = main_color;
	}

	return (
		<span class={'bar_guide' + ((answer_state) ? ' is_' + answer_state : '')}>
			<span class="bar" style={bar_styles}></span>
		</span>
	)
};

const RoundedButton = (props) => {
	var Component = null;
	switch(props.component_type) {
		case 'save':
			Component = SaveButton;
			break;
		case 'link':
			Component = ActionLink;
			break;
		case 'button':
		default:
			Component = ActionButton;
			break;
	}

	var new_props  = {...props, color:'variable', _class:{...props._class}, style:{background:props.main_color}};
	new_props.component_type = null;
	new_props.children = null;

	return (
		<div class="gui_rounded_bordered_button">
			<Component {...new_props}>{props.children}</Component>
		</div>
	)
}

const Wrapper = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const anim_ini = (props.anim_ini != undefined) ? props.anim_ini : false;
	const only_contents = (props.only_contents != undefined) ? props.only_contents : false;
	const hide_sidebar = (props.hide_sidebar != undefined) ? props.hide_sidebar : false;

	const counter_seconds = (props.counter_seconds != undefined && !Number.isNaN(props.counter_seconds)) ? props.counter_seconds : false;
	const on_counter_ends = (props.on_counter_ends != undefined) ? props.on_counter_ends : null;
	const type = (props.type != undefined) ? props.type : "projection";

	const title = (props.title != undefined && props.title != '') ? props.title : false;
	const organizer = (props.organizer != undefined && props.organizer != '') ? props.organizer : false;

	const qr = (props.qr != undefined) ? props.qr : false;
	const qr_size = Math.min(window.innerWidth, window.innerHeight);

	const display_gif = (props.display_gif != undefined) ? props.display_gif : false;
	const qr_zoomed_in = (props.qr_zoomed_in != undefined) ? props.qr_zoomed_in : false;
	const manage = (props.manage != undefined) ? props.manage : false;

	return (
		<section class={'gui_live_contest is_' + type} style={(display_gif) ? { background:props.main_color } : null}>
			<div style={{width:'100%', display:'flex', flexGrow:'1', height:((title || organizer) ? 'calc(100% - 30px)' : '100%'), background:((display_gif) ? 'rgba(0, 0, 0, 0.3)' : 'transparent')}}>
				{(!manage && !only_contents) && (
					<aside class={'participants' + ((!hide_sidebar && !qr_zoomed_in && !display_gif) ? ' visible' : '') + ((anim_ini) ? ' animated' : '')}>
						<div class="side_contens">
							<h2 class="title" style={{background:props.main_color}}>{i18n("Participants")} ({_size(props.participants)})</h2>
							{(props.participants != undefined && _size(props.participants) > 0) && (
								<ul class="participants_list">
									{props.participants.map((item, i) => {
										const is_new = (item.new != undefined) ? item.new : false;

										const participant_position = parseInt(item.position);
										const participation_time = parseInt(item.time) - parseInt(props.start); // seconds
										const participation_min = Math.floor(participation_time / 60);
										const participation_sec = Math.round(participation_time % 60);

										return (
											<li key={'s'+i} class={(is_new && anim_ini && false) ? 'is_new' : null}>
												<div>
													<div class="gui_pos_rel participant_name">
														<strong class="gui_cutTextOnOverflow">#{participant_position} {item.name}</strong>
													</div>

													<span class="time gui_pos_rel">
														<DigitImage
															value={(participation_min < 10) ? ('0' + participation_min) : participation_min}
														/>

														<span class="is_separator">
															<DigitImage
																value={"colon"}
															/>
														</span>

														<DigitImage
															value={(participation_sec < 10) ? ('0' + participation_sec) : participation_sec}
														/>
													</span>
												</div>
											</li>
										)
									})}
								</ul>
							)}
						</div>
					</aside>
				)}

				{(qr && qr_zoomed_in && !only_contents) && (
					<div class="gui_flexbox gui_flex_col gui_flex_center" style={{ paddingLeft:'2svh' }}>
						<div onClick={props.toggleZoomQr} class="qr_code big">
							<QRCode
								value={qr}
								size={qr_size}
							/>
						</div>
					</div>
				)}

				<article class={'contents' + ((qr && qr_zoomed_in && !only_contents) ? ' with_zoomed_qr' : '') + ((display_gif) ? ' with_gif' : '')}>
					{(counter_seconds > 0 && !only_contents) && (
						<aside class="time_counter is_open" style={(display_gif) ? { marginBottom:'5svh', zoom:'0.6' } : null}>
							<TimeCounterPerform
								format="m:s.d"
								type='clock'
								display_if_zero={((qr && qr_zoomed_in)) ? false : true}
								label_color={props.main_color}
								only_digit={false}
								in_text={false}
								full_labels={true}
								seconds={counter_seconds}
								onEnd={on_counter_ends}
							/>
						</aside>
					)}

					{props.children}
				</article>
			</div>

			{((title || organizer) && !only_contents) && (
				<footer class="footer" style={{width:'100%', flexShrink:'0', background:props.main_color}}>
					{(title) && (
						<h1 class="title">{title}</h1>
					)}
					{(organizer) && (
						<p class="organizer">{organizer}</p>
					)}
				</footer>
			)}
		</section>
	)
}

class SweepsLiveProjection extends Component {
	constructor(props, context) {
		super(props, context);

		this.sound_files_path = '/fla_canvas/live_sweeps/audio/';

		this.reaction_gifs = (props.reaction_gifs != undefined) ? props.reaction_gifs : false;
		this.not_used_reaction_gifs = {...this.reaction_gifs};

		this.state = {
			actual_question:false,
			audio_status:false,
			display_gif:false,
			display_pre_giveaway:false,
			display_start_counter:false,
			display_message_cache:false,
			has_clicked_on_trap:false,
			index_question:0,
			last_participant_id:0,
			live_url:false,
			manage:{
				done:false,
				logged:false,
				logged_pin:'',
				qr_zoomed_in:false,
				gif:false,
				stats:false,
				show_stats:false,
				show_ranking:false,
				stopped_from_projector:props.values.end < props.values.now ? true : false,
			},
			partials_stats:{},
			participants:[],
			qr_zoomed_in:false,
			question_stats:[],
			show_index_stats:0,
			show_stats:false,
			show_ranking:false,
			stats:false,
			sweep:props.sweep,
			used_gifs:[],
			values:props.values,
		}

		this.has_manual_started = false;
		this.has_automatic_ended = false;
		this.first_loaded = true;
		this.bg_song = null;
		this.interval_participants;
		this.call_participants;

		this.audio_gong_filename = this.sound_files_path + 'gong';

		window.handleClickProjection = this;
	}

	componentWillMount() {
		importCSS('comp/live_contest.css');
		importCSS('comp/quiz.css');
	}

	componentDidMount() {
		const duration = Math.min(5, Math.max(1, Math.floor(this.state.sweep.config.form.seconds / 60)));
		const file_ext = ($('html').hasClass('is_firefox')) ? 'ogg' : 'mp3';

		this.bg_song = this.loadSound(this.sound_files_path + 'bso/' + duration + 'min.' + file_ext);

		this.bg_song.onloadstart = () => { this.audio_start(); };
		this.bg_song.onprogress = () => { this.audio_progress(); };
		this.bg_song.oncanplaythrough = () => { this.audio_loaded(); };

		if(this.state.values.end && this.state.values.now > this.state.values.end) {
			this.timeParticipants();
		}

		setTimeout(() => {
			this.setState({display_message_cache:true});
		}, 2000);

	}

	start(cb) {
		const sweep_id = this.props.values.id;

		var data = {};
		data.action = 'start';

		$.ajax({
			url:getRemotedbUrl('/action/' + sweep_id + '/' + data.action),
			data:data,
			async: true,
			dataType:'json',
			type:'POST',
			success:(r) => {
				this.has_manual_started = true;
				const values = r.values;
				this.state.values.start = values.start;
				this.state.values.now = values.now;
				this.state.values.end = values.end;

				if(values.start == values.now) {
					this.startCounterAnimation(cb);
				} else {
					setTimeout(() => {
						this.setState({ display_start_counter:false });
						if(window.location.hash != '#manage')this.timeParticipants(cb);
					}, 100);
				}
			}
		});
	}

	startCounterAnimation(cb) {
		if(typeof(window.playCounter) == 'function') {
			this.state.display_start_counter = true;
			this.setState({...this.state});
			window.playCounter();

			setTimeout(() => {
				this.setState({ display_start_counter:false });
				this.soundPlay();
				if(window.location.hash != '#manage') {
					this.timeParticipants(cb);
				}
			}, (3 * 1000 + 500));
		}
	}

	toggleZoomQr() {
		this.first_loaded = false;
		this.setState({ qr_zoomed_in:!this.state.qr_zoomed_in, display_gif:false });
	}

	cleanNewParticipants() {
		this.state.participants.map((participant, i) => {
			this.state.participants[i].new = false;
		});
	}

	timeParticipants(cb) {
		if(this.interval_participants)clearInterval(this.interval_participants);
		this.interval_participants = setInterval(()=>{
			this.intervalParticipants(cb);
		},5000);
	}

	intervalParticipants(cb) {
		if(this.call_participants)this.call_participants.abort();

		var sweep_id = this.state.values.id;
		var data = {};
		data.action = 'participants';
		data.last_participant_id = this.state.last_participant_id;

		this.call_participants = $.ajax({
			url:getRemotedbUrl('/action/' + sweep_id + '/' + data.action),
			type:"POST",
			data:data,
			timeout:30000,
			dataType:'json',
			success:(r) => {
				if(r.status) {
					if(r.participants != undefined) {
						this.cleanNewParticipants();

						$.each(r.participants, (index, participant) => {
							participant.new = true;
							this.state.participants.unshift(participant);
						});

						this.state.last_participant_id = r.last_participant_id;
						this.setState({...this.state});
					}

					if(_size(this.state.participants)>=this.state.values.limit_participants){
						this.game('stop');
					}
				}
			},
			error:(x, t, m) => {
			}
		});
	}

	game(action, cb) {
		action = (action != undefined) ? action : false;
		var is_end = false;

		if(action == 'stop') {
			this.state.values.now = parseInt(this.state.values.end) + 1;//ENDnot zero
			is_end = true;
		}

		if(is_end) {
			this.has_automatic_ended = true;
			this.stop_game(cb);
		}
		this.setState({...this.state});

		if(cb != undefined) cb();
	}

	stop_game(cb) {
		const sweep_id = this.state.values.id;
		var data = {};
		data.action = 'stop';
		$.post(getRemotedbUrl('/action/' + sweep_id + '/' + data.action), data, ()=>{
			this.soundStop();
		});

		this.socket.emit('live_sweep', { sweep_id:sweep_id, action:'stop_manage' });
		if(cb != undefined) cb();
		clearInterval(this.interval_participants);
	}

	show_ranking(cb) {
		this.state.show_ranking = true;
		this.setState({...this.state});
		window.location.hash = 'ranking';
	}

	giveaway(cb) {
		this.setState({ display_pre_giveaway:true });

		const sweep_id = this.state.values.id;
		var data = {};
		data.action = 'do_sweep';
		$.ajax({
			url:getRemotedbUrl('/action/' + sweep_id + '/' + data.action),
			data:data,
			async:true,
			dataType:'json',
			type:'POST',
			success:(r) => {
				this.state.values = r.values;
				if(r.values.do_sweep != undefined && r.values.do_sweep) {
					window.handleClickSettings.doSweep(0, 1, (r) => {
						if(r.status) {
							this.state.live_url = r.live_url;
							this.setState({...this.state});
							window.location.hash = 'draw';
							this.setState({ display_pre_giveaway:false });
						}
					});
				} else {
					//alert("Sorry, there are less participants than winners");
				}
			}
		});

		if(cb != undefined) cb();
	}

	get_stats(cb) {
		const sweep_id = this.state.values.id;
		var has_questions = (this.props.questions != undefined && _size(this.props.questions) > 0) ? true : false;
		if(has_questions) {
			if(!this.state.stats) {
				var data = {};
				data.action = 'stats';
				$.ajax({
					url:getRemotedbUrl('/action/' + sweep_id + '/' + data.action),
					data:data,
					async:true,
					dataType:'json',
					type:'POST',
					success:(r) => {
						this.state.stats = r.questions;
						//this.setState({...this.state});
						window.location.hash = 'stats';
						this.stats(this.state.show_index_stats,cb);
						if(cb != undefined) cb();
					}
				});
				this.resultStats();
			} else {
				if(cb != undefined) cb();
			}
		} else {
			if(cb != undefined) cb();
		}
	}

	stats(index, display, cb) {
		this.setState({...this.state});

		var question_stats = {
			answers:[],
			question:this.props.questions[index],
			total_answers:0,
		};

		this.props.questions[index].answers.map((jtem, j) => {
			var answer_count = (this.state.stats[index] != undefined && this.state.stats[index][jtem.value] != undefined) ? this.state.stats[index][jtem.value] : 0;
			question_stats.answers.push({
				text:jtem.label,
				count:answer_count,
				status:(question_stats.question.type == 'quiz') ? ((String(jtem.checked) == 'true') ? 'ok' : 'ko') : false,
			});
			question_stats.total_answers += parseInt(answer_count);
		});

		this.state.show_stats = display;
		this.state.question_stats = question_stats;
		this.state.show_index_stats = index;
		this.setState({...this.state});
		if(cb != undefined) cb();
	}

	addTime() {
		const sweep_id = this.state.values.id;
		var data = {};
		data.action = 'add_time';
		$.ajax({
			url:getRemotedbUrl('/action/' + sweep_id + '/' + data.action),
			data:data,
			async:true,
			dataType:'json',
			type:'POST',
			success:(r) => {
				window.TimeClick.addSeconds(15)
				this.state.values = r.values
				this.setState({...this.state});
			}
		});
	}

	clickOnTrap() {
		var values = this.state.values;
		if(window.location.hash == '#manage') return;
		this.alreadyon = false;
		var socket = io(window.socket_url);
		this.socket = socket;
		window.socket = this.socket;
		this.socket.on('connect', () => {
			this.socket.emit('join_sweep', { sweep_id:values.id, type:'projector' });
			if(this.alreadyon) return;

			this.alreadyon = true;
			//Now try to join to the promotion room

			this.socket.on('live_sweep', (data) => {
				switch(data.action) {
					case 'toogle_qr':
						this.toggleZoomQr();
						break;
					case 'add_time':
						this.addTime();
						break;
					case 'start':
						this.start();
						break;
					case 'stop':
						this.game('stop');
						break;
					case 'stats':
						this.get_stats();
						break;
					case 'cursor_stats':
						this.stats(data.index, data.display);
						break;
					case 'draw':
						this.giveaway();
						break;
					case 'ranking':
						this.show_ranking();
						break;
					case 'gif':
						this.show_gif(data.mode);
						break;
				}
			});
		});

		this.setState({ has_clicked_on_trap:true });
	}

	show_gif(gif_mode) {
		if(gif_mode == false || gif_mode == '0') {
			this.state.display_gif = false;
		} else {
			const random_gif_key = Math.floor((Math.random() * _size(this.not_used_reaction_gifs[gif_mode])));
			this.state.display_gif = this.not_used_reaction_gifs[gif_mode][random_gif_key];

			const reaction_gifs_backup = [...this.reaction_gifs[gif_mode]];
			const index_gif = this.not_used_reaction_gifs[gif_mode].indexOf(this.state.display_gif);
			this.not_used_reaction_gifs[gif_mode].splice(index_gif, 1);
			this.reaction_gifs[gif_mode] = reaction_gifs_backup;

			if(_size(this.not_used_reaction_gifs[gif_mode]) == 0) {
				this.not_used_reaction_gifs[gif_mode] = reaction_gifs_backup;
			}

			if(window.location.hash != '#manage') {
				this.socket.emit('live_sweep', { sweep_id:this.state.values.id, action:'gif_to_manage', value:this.state.display_gif });
			}

			this.state.qr_zoomed_in = false;
		}

		this.setState({ ...this.state });
	}

	resultStats() {
		const actual_index = this.state.show_index_stats;
		const participants = this.state.participants;
		const questions = (this.props.questions != undefined) ? this.props.questions : false;
		var totals = {};
		var part = participants.slice(0);
		for(var i = 0; i < questions.length; i++){
			part = part.filter((obj)=>{
				return obj.correct != undefined && obj.correct[i] != undefined && obj.correct[i] == i
			});
			totals[i] = part.length;
		}
		this.setState({partials_stats:totals})
	}

	loadSound(src) {
		var sound = document.createElement('audio');
		if("src" in sound) {
			sound.autoPlay = false;
			sound.id = 'bso_audio';
			sound.src = src + '?v=0.0001';

			sound.load();

			document.body.appendChild(sound);

			return sound;
		}
	}

	audio_start() {
		this.state.audio_status = 'start';
		this.setState({ ...this.state });
	}

	audio_progress() {
		this.state.audio_status = 'loading';
		this.setState({ ...this.state });
	}

	audio_loaded() {
		this.state.audio_status = 'loaded';
		var t = setTimeout(() => {
			this.setState({ ...this.state });
		}, 1000);
	}

	soundPlay() {
		this.bg_song.play();
	}

	soundStop() {
		this.bg_song.pause();
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const values = this.state.values;
		const questions = (this.props.questions != undefined) ? this.props.questions : false;
		const has_questions = (questions && _size(questions) > 0) ? true : false;

		var is_quiz = false;
		questions.map((item, i) => {
			if(item.type == 'quiz') is_quiz = true;
		})

		const has_admin_manually_started = this.has_manual_started;
		const has_contest_finished = ((values.end && values.end <= values.now) || this.has_automatic_ended) ? true : false;

		const actual_show_index_stats = parseInt(this.state.show_index_stats);
		const next_show_index_stats = parseInt(actual_show_index_stats) + 1;

		var props_wrapper = {
			title:values.title,
			organizer:values.organizer,
			participants:this.state.participants,
			anim_ini:this.first_loaded,
			start:values?.start ?? false,
			intl:this.props.intl,
			main_color:values.main_color,
			counter_seconds:((!has_contest_finished && has_admin_manually_started) ? (parseInt(values.end) - parseInt(values.now)) : null),
			qr:values.qr,
			qr_zoomed_in:(has_contest_finished && values.status != const_sweep.CLOSED) ? false : this.state.qr_zoomed_in,
		};

		const make_sweeps_label = (this.state.sweep.config.num_winners > 1) ? "AND THE WINNERS ARE" : "AND THE WINNER IS";

		if(window.location.hash == '#manage') {
			//Seccio de Manage
			return (
				<SweepsLiveProjectionManage
					params_state={this.state}
					params_props={this.props}
					reaction_gifs={this.reaction_gifs}
				/>
			)
		}

		if(this.state.display_pre_giveaway) {
			return (
				<Wrapper only_contents={true} {...props_wrapper}>
					<Spinner
						color='rgba(var(--main-bg-color), 1)'
					>Finalizing giveaway. Please wait.</Spinner>
				</Wrapper>
			)
		}

		if(!this.state.has_clicked_on_trap) {
			return (
				<Wrapper {...props_wrapper} hide_sidebar={true}>
					{(this.state.audio_status != 'loaded') ? (
						<Spinner
							color='rgba(var(--main-bg-color), 1)'
							autotranslate={false}
						>
							{i18n("Loading show. Please wait.")}
							{(this.state.display_message_cache) && (
								<div class="gui_not_in_top">
									<p>{i18n("We are initializing the cache of the browser")}</p>
									<p>{i18n("If it takes more than 5 seconds loading, please refresh the page.")}</p>
								</div>
							)}
						</Spinner>
					) : (
						<RoundedButton
							main_color={this.state.values.main_color}
							onClick={() => this.clickOnTrap()}
							autotranslate={false}
						>{i18n("Ready!")} {i18n("Click to start")}</RoundedButton>
					)}
				</Wrapper>
			)
		}

		if(has_contest_finished && this.state.values.status != const_sweep.CLOSED) {
			const has_button_draw = (_size(this.state.participants) >= parseInt(this.state.values.total_winners)) ? true : false;

			return (
				<Router hashType="noslash">
					<div>
						<Route path="/" exact={true} render={(route) => {
							return (
								<Wrapper {...props_wrapper} hide_sidebar={true} anim_ini={false}>
									<div>
										<div class="floating_info">
											<h1 class="title">{i18n("Time's up!")}</h1>

											{(!has_button_draw && !has_questions) && (
												<p class="organizer">{i18n("Sorry, there are less participants than winners and alternates")}</p>
											)}
										</div>

										{(has_questions) ? (
											<RoundedButton
												main_color={this.state.values.main_color}
												onClick={(e, cb) => this.get_stats(cb)}
											>NEXT</RoundedButton>
										) : (
											(has_button_draw) && (
												<RoundedButton
													main_color={this.state.values.main_color}
													component_type="save"
													onClick={(e, cb) => this.giveaway(cb)}
												>{i18n(make_sweeps_label) + '...'}</RoundedButton>
											)
										)}

										<audio autoPlay="autoplay">
											<source
												src={this.audio_gong_filename + '.mp3?v=1.1'}
												type="audio/mpeg"
											/>

											<source
												src={this.audio_gong_filename + '.ogg?v=1.1'}
												type="audio/ogg"
											/>

											<embed
												autostart="true"
												hidden={true}
												loop={false}
												src={this.audio_gong_filename + '.mp3?v=1.1'}
											/>
										</audio>
									</div>
								</Wrapper>
							)
						}} />

						<Route path="/stats" exact={true} render={(route) => {
							if(!this.state.stats) window.location.hash = '';

							const partials_stats = this.state.partials_stats;
							const participants = this.state.participants;

							var finalists_still_label = "{partial} participant still in the game";
							if(partials_stats[(this.state.show_stats) ? actual_show_index_stats : actual_show_index_stats - 1] > 1) {
								finalists_still_label = "{partial} participants still in the game";
							}

							const has_button_draw = (_size(this.state.participants) >= parseInt(this.state.values.total_winners)) ? true : false;

							return (
								<Wrapper {...props_wrapper} hide_sidebar={true} anim_ini={false}>
									<div class="project_question">
										{(this.state.question_stats.question != undefined) && (
											<div class="gui_question_stat">
												<ul>
													<li class="gui_answer_stat">
														<ul class="gui_stats_list">
															{(!this.state.show_stats) ? (
																<li class="only_question">
																	<p class="stat_label">
																		<span class="question_number gui_not_in_bottom">
																			<FormattedMessage
																				id="Question #{question_number}"
																				values={{question_number:(actual_show_index_stats + 1)}}
																			/>
																		</span>

																		<span class="question_text gui_pos_rel gui_flexbox gui_flex_align_center gui_text_align_center">
																			<strong>{this.state.question_stats.question.text}</strong>
																		</span>
																	</p>
																</li>
															) : (
																<li class="question_with_answers">
																	<p class="stat_label">
																		<span class="question_number gui_not_in_bottom_tiny">
																			<FormattedMessage
																				id="Question #{question_number}"
																				values={{question_number:(actual_show_index_stats + 1)}}
																			/>
																		</span>

																		<span class="question_text gui_pos_rel gui_flexbox gui_flex_align_center">
																			<span class="gui_cutTextOnOverflow gui_text_align_center">
																				<strong>{this.state.question_stats.question.text}</strong>
																			</span>
																		</span>
																	</p>

																	{this.state.question_stats.answers.map((answer, t) => {
																		const percent = Math.ceil(answer.count / this.state.question_stats.total_answers * 100);
																		const total = answer.count;
																		return (
																			<span class="answer_cont" key={'stats'+t}>
																				<p class="gui_pos_rel">
																					<span class="gui_cutTextOnOverflow">{answer.text}</span>
																				</p>

																				<ChartRowBar
																					state={answer.status}
																					width={percent}
																					main_color={((!is_quiz) ? this.state.values.main_color : null)}
																				/>

																				{(percent > 0) && (
																					<span class="percent_indicator"><FormattedMessage id="{participants} out of {total_participants} participants ({percent}%)" values={{participants:total, total_participants:_size(participants), percent:percent}} /></span>
																				)}
																			</span>
																		)
																	})}
																</li>
															)}
														</ul>
													</li>
												</ul>
											</div>
										)}

										{((((this.state.show_stats && next_show_index_stats >= _size(questions)) || !has_questions) && is_quiz) || (is_quiz && partials_stats[(this.state.show_stats) ? actual_show_index_stats : actual_show_index_stats - 1] != undefined)) && (
											<p style={{fontSize:'2em', position:'relative', top:'-0.5em'}}>🔥 <FormattedMessage id={finalists_still_label} values={{partial:partials_stats[(this.state.show_stats) ? actual_show_index_stats : actual_show_index_stats - 1], total:_size(participants)}} /> 🔥</p>
										)}

										<ButtonCollection>
											{(!this.state.show_stats && has_questions) && (
												<RoundedButton
													main_color={this.state.values.main_color}
													onClick={(e, cb) => this.stats(actual_show_index_stats,true, cb)}
												>View results</RoundedButton>
											)}

											{(this.state.show_stats && next_show_index_stats < _size(questions) && has_questions) && (
												<RoundedButton main_color={this.state.values.main_color} component_type="save" onClick={(e, cb) => this.stats(next_show_index_stats,false, cb)}>NEXT</RoundedButton>
											)}

											{(((this.state.show_stats && next_show_index_stats >= _size(questions)) || !has_questions) && !is_quiz) && (
												<div>
													{(!has_button_draw) ? (
														<div class="floating_info"><p class="organizer">{i18n("Sorry, there are less participants than winners and alternates")}</p></div>
													) : (
														<RoundedButton main_color={this.state.values.main_color} component_type="save" onClick={(e, cb) => this.giveaway(cb)}>{i18n(make_sweeps_label) + '...'}</RoundedButton>
													)}
												</div>
											)}

											{((this.state.show_stats && next_show_index_stats >= _size(questions)) && is_quiz) && (
												<RoundedButton main_color={this.state.values.main_color} component_type="save" onClick={(e, cb) => this.show_ranking(cb)}>Ranking</RoundedButton>
											)}
										</ButtonCollection>
									</div>
								</Wrapper>
							)
						}} />

						<Route path="/ranking" exact={true} render={(route) => {
							if(!this.state.stats) window.location.hash = '';
							/*if(!is_quiz || next_show_index_stats != _size(questions) || !this.state.values.end) {
								window.location.hash = '';
								return;
							}*/
							var participants = this.state.participants;
							participants = _orderBy(participants, ['result', 'id'], ['desc', 'asc']);

							const participants_ok = participants.filter(function(obj) { return _size(questions) == obj.result});

							const has_draw = (_size(participants_ok) >= parseInt(this.state.values.total_winners)) ? true : false;

							var finalists_label = "Finalist";
							var finalists_still_label = "{partial} participant still in the game";
							if(_size(participants_ok) > 1) {
								finalists_still_label = "{partial} participants still in the game";
								finalists_label = "Finalists";
							}

							const max_users_to_display = 5;
							const title = (_size(participants_ok) > max_users_to_display) ? "Top 5" : finalists_label;

							const real_users_to_display = Math.min(max_users_to_display, _size(participants_ok));

							return (
								<Wrapper {...props_wrapper} anim_ini={false} hide_sidebar={true} type="ranking">
									<div class="project_ranking">
										<div class="gui_question_stat">
											<div class="floating_info">
												<h1 class="title">{i18n(title)}</h1>
												{(real_users_to_display <= 0) && (
													<p class="organizer">{i18n("Sorry, there aren't winners")}</p>
												)}
											</div>
											{(real_users_to_display > 0) && (
												<table class="gui_ranking_table" width="100%" cellPadding="0" cellSpacing="0">
													<thead>
														<tr>
															<th class="not_centered" style={{width:'10%'}}>{i18n("Rank")}</th>
															<th class="not_centered">{i18n("Participant")}</th>
															<th style={{width:'15%'}}>{i18n("points", 'ucfirst')}</th>
															<th style={{width:'15%'}}>{i18n("Time")}</th>
														</tr>
													</thead>
													<tbody>
														{participants.slice(0, real_users_to_display).map((item, i) => {
															const participant_position = parseInt(item.position);
															const participant_result = item.result != undefined ? parseInt(item.result) : false;

															const participant_index = (participant_position < 10) ? ('0' + participant_position) : participant_position;
															const participation_time = parseInt(item.time) - parseInt(this.state.values.start); // seconds

															const participation_min = Math.floor(participation_time / 60);
															const participation_sec = Math.round(participation_time % 60);

															const index = (i < 9) ? '0' + (i + 1) : (i + 1);

															return (
																<tr key={i}>
																	<td class="digited not_centered">
																		<DigitImage
																			value={index}
																			color={this.state.values.main_color}
																		/>
																	</td>

																	<td class="not_centered">
																		<strong>#{participant_position} {item.name}</strong>
																	</td>

																	<td class="digited">
																		<DigitImage
																			value={participant_result}
																		/>
																	</td>

																	<td class="digited">
																		<span class="time gui_pos_rel gui_flexbox_auto gui_flex_center">
																			<DigitImage
																				value={(participation_min < 10) ? ('0' + participation_min) : participation_min}
																			/>

																			<span class="is_separator">
																				<DigitImage
																					value={"colon"}
																				/>
																			</span>

																			<DigitImage
																				value={(participation_sec < 10) ? ('0' + participation_sec) : participation_sec}
																			/>
																		</span>
																	</td>
																</tr>
															)
														})}
													</tbody>
												</table>
											)}
										</div>

										{(is_quiz && has_draw && real_users_to_display < _size(participants_ok)) && (
											<p style={{fontSize:'3em', position:'relative', top:'-0.2em', lineHeight:'1.5em', fontWeight:'bold'}}>🔥 <FormattedMessage id={finalists_still_label} values={{partial:_size(participants_ok), total:_size(participants)}} /> 🔥</p>

										)}

										{(has_draw) && (
											<ButtonCollection>
												<RoundedButton
													main_color={this.state.values.main_color}
													component_type="save"
													onClick={(e, cb) => this.giveaway(cb)}
													autotranslate={false}
												>{i18n(make_sweeps_label) + '...'}</RoundedButton>
											</ButtonCollection>
										)}
									</div>
								</Wrapper>
							)
						}} />

						<Route path="/manage" exact={true} render={(route) => {
							if(!has_admin_manually_started) {
								return(
									<div>
										<RoundedButton
											main_color={this.state.values.main_color}
											component_type="save"
											onClick={(e, cb) => this.start(cb)}
										>{((this.state.values.start) ? "Resume" : "Go live")}</RoundedButton>
									</div>
								)
							}

							return (
								<div />
							)
						}} />

						<Route path="/draw" exact={true} render={(route) => {
							if((has_questions && next_show_index_stats != _size(questions) || !has_contest_finished)) window.location.hash = '';
							return (
								<div>
									<iframe
										src={this.state.live_url+'?autoplay_mode=1'}
										style={{height:'100dvh', width:'100vw', border:'none', zIndex:'99999', position:'relative'}}
										allow="autoplay"
									/>

									<Wrapper only_contents={true} {...props_wrapper}>
										<Spinner
											color='rgba(var(--main-bg-color), 1)'
										>Finalizing giveaway. Please wait.</Spinner>
									</Wrapper>
								</div>
							)
						}} />

						<SweepSettings
							sweep={this.state.sweep}
							render={false}
						/>
					</div>
				</Router>
			)
		}

		if(this.state.display_start_counter) {
			return null;
		}

		if(!has_admin_manually_started) {
			return (
				<Wrapper hide_sidebar={true} {...props_wrapper}>
					<div class="floating_info">
						{(this.state.values.title) && (
							<h1 class="title">{this.state.values.title}</h1>
						)}

						{(this.state.values.organizer) && (
							<p class="organizer">{this.state.values.organizer}</p>
						)}

						<ul class="visible_prizes">
							{this.state.sweep.config.prizes.map((prize, p) => {
								return (
									<li key={p}>{prize.qty} × <strong>{prize.name}</strong></li>
								)
							})}
						</ul>
					</div>

					<RoundedButton
						main_color={this.state.values.main_color}
						component_type="save"
						onClick={(e, cb) => this.start(cb)}
					>{((this.state.values.start) ? "Resume" : "Start")}</RoundedButton>
				</Wrapper>
			)
		}

		const qr_size = Math.min(window.innerWidth, window.innerHeight);

		var protomatch = /^(https?|ftp):\/\//; // NB: not '.*'
		var sweep_live_url = (window.sweepslive_url).replace(protomatch, '').replace('/', '');

		const display_gif = (this.state.display_gif && this.state.display_gif !== false) ? true : false;

		return (
			<div>
				<Wrapper {...props_wrapper} on_counter_ends={(action, cb) => this.game('stop', cb)} toggleZoomQr={() => this.toggleZoomQr()} display_gif={display_gif}>
					{(display_gif) ? (
						<div class="gui_reaction_gif">
							<img src={this.state.display_gif} height="100%" alt="" />
						</div>
					) : (
						<div class="gui_flexbox_auto gui_flex_row gui_flex_center">
							{(this.state.values.qr && !this.state.qr_zoomed_in) && (
								<div>
									<div onClick={() => this.toggleZoomQr()} class="qr_code small">
										<QRCode value={this.state.values.qr} size={qr_size} />
									</div>
								</div>
							)}
							<div class="link_access">
								<FormattedMessage id="Go to: {link} and enter the LIVE ID: {live_id}" values={{link:<span class="fill_part">{sweep_live_url}</span>, live_id:<span class="fill_part" style={{paddingTop:'7px'}}>{this.state.values.pin}</span>}} />
							</div>
						</div>
					)}
				</Wrapper>
			</div>
		)
	}
}

export default injectIntl(SweepsLiveProjection);